<template>
  <div class="common-page order-management">
    <div class="top-box">
      <div class="search-table-box">
        <div class="list-box">
          <div class="list-box-num">{{ overviewData.settledNum }}</div>
          <div class="list-box-label">已结算</div>
        </div>
        <div class="list-box">
          <div class="list-box-num">￥{{ numberToThousand(overviewData.settledAmount) }}</div>
          <div class="list-box-label">已结算金额</div>
        </div>
        <div class="list-box">
          <div class="list-box-num">{{ overviewData.unSettledNum }}</div>
          <div class="list-box-label">待结算</div>
        </div>
        <div class="list-box">
          <div class="list-box-num">￥{{ numberToThousand(overviewData.unSettledAmount) }}</div>
          <div class="list-box-label">待结算金额</div>
        </div>
      </div>
      <div class="search-form-box">
        <el-row :gutter="30">
          <el-form inline>
            <el-col :span="5">
              <el-form-item label="结算单号:" prop="settlementNo">
                <el-input clearable placeholder="请输入" v-model="searchForm.settlementNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5" v-if="companyType === '1'">
              <el-form-item label="分公司:">
                <el-select style="width: 100%" v-model="searchForm.belongCompanyId" placeholder="请选择">
                  <el-option
                    v-for="item in belongCompanyData"
                    :key="item.companyId"
                    :label="item.companyName"
                    :value="item.companyId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="代理商:" prop="companyId">
                <el-select
                  style="width: 100%"
                  v-model="searchForm.companyId"
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="item in agentData"
                    :key="item.companyId"
                    :label="item.companyName"
                    :value="item.companyId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="结算状态:" prop="settlementStatus">
                <el-select
                  style="width: 100%"
                  v-model="searchForm.settlementStatus"
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="item in settlementStatusData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="">
                <el-button type="primary" round icon="el-icon-search" @click="handleCheck()"></el-button>
                <el-button type="default" round icon="el-icon-refresh" @click="handleReset(['belongCompanyId'])"></el-button>
                <el-button type="primary" @click="handleDownload('结算单.xlsx')" :loading="downloadLoading">导出</el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </div>
    </div>

    <div class="custom-table-box">
      <custom-table
        :data="tableData"
        :column="tableColumn"
        :total="tableOptions.total"
        :loading="tableOptions.loading"
        :page="tableOptions.pageNumber"
        :size="tableOptions.pageSize"
        :selection="false"
        @pagination="handleSizeChange">
        <template v-slot:sourceType="{ row }">
          <span v-if="row.sourceType === 1">平台结算</span>
          <span v-if="row.sourceType === 2">第三方结算</span>
        </template>
        <template v-slot:billId="{ row }">
          <span v-if="row.sourceType === 1">手动结算</span>
          <span v-if="row.sourceType === 2">{{row.startTime}} - {{row.endTime}}</span>
        </template>
        <template v-slot:settlementStatus="{ row }">
          <el-tag type="danger" v-if="row.settlementStatus === 0">未结算</el-tag>
          <el-tag type="primary" v-if="row.settlementStatus === 1">已结算</el-tag>
        </template>
        <template v-slot:operation="{ row }">
          <span class="operate-btn" @click="handleDetail(row)">详情</span>
          <span class="operate-btn" @click="handleChu(row)" v-if="row.settlementStatus === 0">结算</span>
          <span class="operate-btn" @click="handleDownloadDetail(row)">导出</span>
          <span class="operate-btn" @click="handleDelete(row.billId)" v-if="row.settlementStatus === 0">删除</span>
        </template>
      </custom-table>
    </div>
    <detail ref="detail"></detail>
    <jie-suan ref="jieSuanRef"></jie-suan>
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import CustomDateRange from "@/components/CustomDateRange.vue";
import tableMixin from "@/mixin/tableMixin";
import CustomTabBox from "@/components/customComponents/CustomTabBox.vue";
import { blobToText, downloadFileCustom, numberToThousand } from "@/utils/tool";
import { downloadDetail, downloadTable, getPage, overview, deleteInfo } from "./api";
import { getSelectAgent } from "@/views/SystemManagement/AgentManagement/api";
import Detail from "./detail.vue";
import { Loading } from 'element-ui';
import JieSuan from "@/views/FinancialManagement/AgentSettlementBill/statementAccount/jieSuan.vue";
export default {
  name: "ShipperManagement",
  mixins: [tableMixin],
  components: {
    JieSuan,
    Detail,
    CustomTabBox,
    OperateBox,
    CustomTable,
    CustomDateRange,
  },
  data() {
    return {
      getTableMethod: getPage,
      deleteMethod: deleteInfo,
      downloadFileMethod: downloadTable,
      overviewData: {},
      searchForm: {
        "companyId": "",
        "belongCompanyId": "",
        "settlementNo": "",
        "settlementStatus": ""
      },
      isImmediatelyGetData: true,
      haveBelongCompany: true,
      tableColumn: [
        {
          label: "结算单号",
          prop: "settlementNo",
          width: "200px",
          align: "left",
          show: true,
        },

        {
          label: "结算来源",
          prop: "sourceType",
          align: "left",
          scopeStatus: true,
          show: true,
        },
        {
          label: "结算周期",
          prop: "billId",
          align: "left",
          scopeStatus: true,
          show: true,
        },
        {
          label: "代理商",
          prop: "companyName",
          align: "left",
          show: true,
        },
        {
          label: "创建人",
          prop: "creator",
          align: "left",
          show: true,
        },
        {
          label: "账单运费",
          prop: "fee",
          align: "left",
          show: true,
        },
        {
          label: "不可退定金",
          prop: "deposit",
          align: "left",
          show: true,
        },
        {
          label: "技术服务费",
          prop: "technicalFee",
          align: "left",
          show: true,
        },
        {
          label: "服务费",
          prop: "managerFee",
          align: "left",
          show: true,
        },
        {
          label: "代收金额",
          prop: "agencyFee",
          align: "left",
          show: true,
        },
        {
          label: "结算金额",
          prop: "settleAmount",
          align: "left",
          show: true,
        },
        {
          label: "状态",
          prop: "settlementStatus",
          align: "left",
          scopeStatus: true,
          show: true,
        },
        {
          label: "操作",
          prop: "operation",
          fixed: "right",
          width: "230px",
          scopeStatus: true,
          show: true,
        },
      ],
      agentData: [],
      settlementStatusData: [
        {
          label: '未结算',
          value: 0,
        },
        {
          label: '已结算',
          value: 1,
        }
      ]
    };
  },
  watch: {
    "searchForm.belongCompanyId":function(val) {
      this.searchForm.companyId = ""
      this.getAgentData(val)
    }
  },
  created() {
    // this.getAgentData()
    this.getOverview()
  },
  mounted() {
  },
  methods: {
    numberToThousand,
    handleOtherThing() {
      this.getOverview()
    },
    getAgentData(val) {
      getSelectAgent({
        belongCompanyId: val,
        keyword: ''
      }).then(response => {
        if (response.code === 200) {
          this.agentData = response.data
        }
      })
    },
    getOverview() {
      overview({
        "companyId": this.searchForm.companyId,
        "settlementNo": this.searchForm.settlementNo,
        "settlementStatus": this.searchForm.settlementStatus,
      }).then(response => {
        if (response.code === 200) {
          this.overviewData = response.data
        }
      })
    },
    handleDownloadDetail(row) {
      let loadingInstance = Loading.service({ fullscreen: true,text: '导出中...' });
      downloadDetail({billId: row.billId})
        .then((res) => {
          blobToText(res.data).then((data) => {
            // // console.log("data", data);
            downloadFileCustom(data, `${row.companyName}结算单.xlsx`);
          });
        })
        .finally(() => {
          loadingInstance.close()
        });
    },
    handleChu(row) {
      this.$refs.jieSuanRef.init(row)
      // this.$confirm(`确定结算？`, "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      //   center: true,
      // }).then(() => {
      //   reconcile({
      //     billId: row.billId,
      //   }).then((res) => {
      //     if (res.code === 200) {
      //       this.getTableData();
      //     }
      //   });
      // });
    },
    handleChangeTab(val) {
      this.searchForm.companyName = ""
      this.searchForm.rechargeMethod = ""
      this.searchForm.walletStatus = ""
      this.tableOptions.pageNumber = 1;
      this.getTableData();
    },
    handleDetail(row) {
      this.$refs.detail.init(row);
    },
  },
};
</script>
<style lang="scss" scoped>
.order-management {
  .top-box {
    .tab-box {
      padding: 0.2rem 0 0 0.2rem;
    }
  }

  .search-table-box {
    display: flex;
    margin: 0.16rem -0.1rem 0;

    .list-box {
      width: 33.33%;
      height: 0.9rem;
      border-radius: 0.08rem;
      background-color: #ffffff;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin: 0 0.1rem;

      .list-box-num {
        font-size: 0.24rem;
        color: #000000;
        padding-bottom: 0.1rem;
        font-weight: bold;
      }

      .list-box-label {
        font-size: 0.14rem;
        color: #434343;
      }
    }
  }

  .search-form-title {
    font-weight: 400;
    font-size: 0.16rem;
    color: #111827;
    line-height: 0.24rem;
    padding-bottom: 0.08rem;
  }

  .custom-table-box {
    padding-top: 0;
  }

  .drop-image {
    width: 0.24rem;
    height: 0.24rem;
  }

  .owner-requirement {
    background-color: rgba(217, 236, 255, 0.5);
    color: #1269ff;
    padding: 0.05rem;
    border-radius: 0.06rem;
  }

  .mileage {
    position: relative;
    padding: 0 0.05rem 0.06rem;
  }

  .mileage::after {
    content: "→";
    position: absolute;
    left: 0;
    bottom: -0.06rem;
    text-align: center;
    width: 100%;
  }
}
</style>
